<div class="grid flex justify-content-center" [class]="onMobile() ? 'max-w-25rem' : 'max-w-33rem'">
    <div class="col-4 flex justify-content-center p-1" [class]="onMobile() ? '' : 'max-w-10rem'" *ngFor="let module of modulesDefault let i = index">
      <button pButton pRipple
        label="{{module.Name}}" (click)="addModule(module);" [disabled]="isDisableAdd(module)"
        class="font-normal border-round flex flex-column"
        [class]="onMobile() ? 'text-base w-7rem h-7rem py-4 text-color surface-100 hover:surface-500' : 'text-xl w-9rem h-9rem py-5 text-color surface-100 hover:surface-500'">
        <p-image src="{{ imageSource(module) }}" alt="{{ module.Name }}" [width]="onMobile() ? '30' : '50'" class="pb-2"></p-image>
      </button>
    </div>
  </div>
  <div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
     <button type="button" pButton pRipple (click)="closeDialog()"
           label="{{ 'CLOSE' | translate }}"
           class="p-button-secondary text-xl font-normal mt-3 sm:mt-0 ml-0 sm:ml-1"
           [ngClass]="dynamicButtonWidth()">
     </button>
  </div>
  